(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    // Deferred gallery media: this carousel stacks every slide in the same box
  // for its crossfade/swipe transition, so native loading="lazy" can't defer
  // off-screen slides (they're all geometrically "visible"). Swap the real
  // src/srcset in once the browser is idle after first paint, or immediately
  // if the user interacts with the gallery before that (swipe/thumbnail
  // click), so nothing critical is delayed and nothing is ever missing.
  (function () {
    function reveal(img) {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }
      img.classList.remove('js-deferred-media');
    }

    function revealAll() {
      document.querySelectorAll('.js-deferred-media').forEach(reveal);
    }

    function schedule() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(revealAll, { timeout: 2500 });
      } else {
        setTimeout(revealAll, 1500);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule);
    } else {
      schedule();
    }

    // Interacting with any gallery (swipe, thumbnail, arrow) before the idle
    // callback fires should reveal immediately, not wait.
    document.addEventListener(
      'pointerdown',
      (event) => {
        if (event.target.closest('media-gallery')) revealAll();
      },
      { passive: true }
    );

    // Sections injected after load (product recommendations, filtered or
    // paginated collection grids, quick add) bring their own deferred images,
    // which the one-off pass above never sees. Reveal those once they land,
    // otherwise a card's hover image stays empty and shows its alt text.
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('.js-deferred-media')) reveal(node);
          node.querySelectorAll('.js-deferred-media').forEach(reveal);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  const STORAGE_KEY = 'ww-size-system';

  const sizeMap = {
    '3':   { UK: 'UK 3',   US: 'US 5',   AU: 'AU 5',   EU: 'EU 36',   CM: '22cm' },
    '3.5': { UK: 'UK 3.5', US: 'US 5.5', AU: 'AU 5.5', EU: 'EU 36.5', CM: '22.5cm' },
    '4':   { UK: 'UK 4',   US: 'US 6',   AU: 'AU 6',   EU: 'EU 37',   CM: '23cm' },
    '4.5': { UK: 'UK 4.5', US: 'US 6.5', AU: 'AU 6.5', EU: 'EU 37.5', CM: '23.5cm' },
    '5':   { UK: 'UK 5',   US: 'US 7',   AU: 'AU 7',   EU: 'EU 38',   CM: '24cm' },
    '5.5': { UK: 'UK 5.5', US: 'US 7.5', AU: 'AU 7.5', EU: 'EU 38.5', CM: '24.5cm' },
    '6':   { UK: 'UK 6',   US: 'US 8',   AU: 'AU 8',   EU: 'EU 39',   CM: '25cm' },
    '6.5': { UK: 'UK 6.5', US: 'US 8.5', AU: 'AU 8.5', EU: 'EU 39.5', CM: '25.5cm' },
    '7':   { UK: 'UK 7',   US: 'US 9',   AU: 'AU 9',   EU: 'EU 40',   CM: '26cm' },
    '7.5': { UK: 'UK 7.5', US: 'US 9.5', AU: 'AU 9.5', EU: 'EU 40.5', CM: '26.5cm' },
    '8':   { UK: 'UK 8',   US: 'US 10',  AU: 'AU 10',  EU: 'EU 41',   CM: '27cm' },
    '8.5': { UK: 'UK 8.5', US: 'US 10.5', AU: 'AU 10.5', EU: 'EU 41.5', CM: '27.5cm' },
    '9':   { UK: 'UK 9',   US: 'US 11',  AU: 'AU 11',  EU: 'EU 42',   CM: '28cm' },
  };

  function applySizeSystem(switcher, system) {
    const picker = switcher.closest('variant-picker') || switcher.closest('.variant-picker');
    if (!picker) return;
    picker.querySelectorAll('.variant-option--size [data-size-uk]').forEach(span => {
      const converted = sizeMap[span.dataset.sizeUk]?.[system];
      if (converted) span.textContent = converted;
    });
    switcher.querySelectorAll('.size-system-btn').forEach(btn => {
      btn.classList.toggle('size-system-btn--active', btn.dataset.system === system);
    });
  }

  function initSwitcher(switcher) {
    if (switcher.dataset.sizeInit) return;
    switcher.dataset.sizeInit = '1';
    const system = localStorage.getItem(STORAGE_KEY) || 'UK';
    applySizeSystem(switcher, system);
    switcher.addEventListener('click', e => {
      const btn = e.target.closest('.size-system-btn');
      if (!btn) return;
      const sys = btn.dataset.system;
      localStorage.setItem(STORAGE_KEY, sys);
      applySizeSystem(switcher, sys);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-size-switcher]').forEach(initSwitcher);
  }

  function reapplyStored() {
    const system = localStorage.getItem(STORAGE_KEY) || 'UK';
    if (system === 'UK') return;
    document.querySelectorAll('[data-size-switcher]').forEach(switcher => {
      applySizeSystem(switcher, system);
    });
  }

  function deferredReapply() {
    requestAnimationFrame(() => requestAnimationFrame(reapplyStored));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('variant:update', deferredReapply);
  document.addEventListener('change', e => {
    if (!e.target.matches('input[type="radio"]')) return;
    if (!e.target.closest('.variant-option--size')) return;
    deferredReapply();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
